module.exports = __webpack_public_path__ + "img/poke.3f058f05.jpg";